import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'

// OBTENER TODOS LOS dbo.Roles 
export const getRoles = async() => {
    const respuesta = await PrivateInterceptor(`IT/Roles`, 'GET')
    return respuesta;
}

// MODIFICAR ROL
export const modificarRol = async(IdRol,data) => {
    const respuesta = await PrivateInterceptor(`IT/Roles/IdRol`, 'PUT', data)
    return respuesta;
}

// AGREGAR ROL
export const agregarRol = async(data) => {
    const respuesta = await PrivateInterceptor(`IT/Roles`, 'POST', data)
    return respuesta;
}